<ng-template #modalPreviewPortal>
    <div class="modal-preview">
        <div class="modal-wrapper">
            <web-shop-cart-mini-cart-preview
                [classes]="classes"
                [data]="data"
                [currency]="(shopSettings$ | async)?.currency"
            ></web-shop-cart-mini-cart-preview>
        </div>
    </div>
</ng-template>

<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "mini_cart_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "mini_cart_modal_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="modalBackgroundColor.value"
                        (colorChangeEvent)="setItemColor($event, modalBackgroundColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-6">
                    <label class="control-label">{{ "control_radius" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="modalBorderRadius.value"
                        (valueChange)="setModalBorderRadius($event)"
                        (blurEvent)="setModalBorderRadius($event)"
                    ></sp-input-num>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "mini_cart_separator_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="separatorColor.value"
                        (colorChangeEvent)="setItemColor($event, separatorColor)"
                    ></web-color-picker>
                </div>
            </div>
        </div>

        <hr class="panel-options-divider" />

        <div class="title">
            {{ "shop_cart_typography" | translate }}
        </div>

        <div class="form-row">
            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "mini_cart_text_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="textColor.value"
                        (colorChangeEvent)="setItemColor($event, textColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "mini_cart_price_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="priceColor.value"
                        (colorChangeEvent)="setItemColor($event, priceColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "mini_cart_old_price_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="oldPriceColor.value"
                        (colorChangeEvent)="setItemColor($event, oldPriceColor)"
                    ></web-color-picker>
                </div>
            </div>
        </div>

        <hr class="panel-options-divider" />

        <div class="title">
            {{ "shop_cart_delete_button_settings" | translate }}
        </div>

        <div class="form-row">
            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "shop_cart_icon_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="deleteButtonIconColor.value"
                        (colorChangeEvent)="setItemColor($event, deleteButtonIconColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "shop_cart_icon_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="deleteButtonBgColor.value"
                        (colorChangeEvent)="setItemColor($event, deleteButtonBgColor)"
                    ></web-color-picker>
                </div>
            </div>
        </div>

        <hr class="panel-options-divider" />

        <div class="title">
            {{ "shop_cart_items_count_button_settings" | translate }}
        </div>

        <div class="form-row">
            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "shop_cart_items_count_button_text_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="countButtonTextColor.value"
                        (colorChangeEvent)="setItemColor($event, countButtonTextColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "shop_cart_items_count_button_bg_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="countButtonBgColor.value"
                        (colorChangeEvent)="setItemColor($event, countButtonBgColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-7">
                    <label class="control-label">{{ "shop_cart_items_count_button_border_color" | translate }}</label>
                </div>
                <div class="col-xs-5 text-right">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="countButtonBorderColor.value"
                        (colorChangeEvent)="setItemColor($event, countButtonBorderColor)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group mb-20">
                <div class="col-xs-6">
                    <label class="control-label">{{ "control_radius" | translate }}</label>
                </div>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [value]="countButtonRounding.value"
                        (valueChange)="setCountButtonRounding($event)"
                        (blurEvent)="setCountButtonRounding($event)"
                    ></sp-input-num>
                </div>
            </div>
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
